import { useDispatch } from 'react-redux'
import { closeLinkModal } from 'store/modals'
import Button from 'ui/components/buttons/Button'
import { notifySuccess, notifyError } from 'ui/components/Notify'
import { FormStyled, FormFields, FormButtons } from './styled'

const Form = ({
  renderFields,
  onSubmit,
  onCancel,
  onReset,
  isSubmitting = false,
}) => {
  const dispatch = useDispatch()

  return (
    <FormStyled
      onSubmit={async (e) => {
        e.preventDefault()

        try {
          const success = await onSubmit()
          if (success) {
            dispatch(closeLinkModal())
            notifySuccess('Ссылка успешно сохранена')
          }
        } catch (error) {
          notifyError(
            error?.data?.message ||
              'Не удалось сохранить ссылку. Попробуйте ещё раз.'
          )
        }
      }}
      noValidate
    >
      <FormFields>{renderFields()}</FormFields>
      <FormButtons>
        <Button title="Сохранить" type="submit" loading={isSubmitting} />
        <Button
          title="Отмена"
          theme="borderBlue"
          type="button"
          onClick={() => {
            onCancel()
            onReset()
          }}
        />
      </FormButtons>
    </FormStyled>
  )
}

export default Form
